/**
 * SC Swiper - Hero Slideshow JavaScript
 * Handles Swiper initialization and functionality
 */

// Global object to store swiper instances for cleanup
window.heroSwiperInstances = window.heroSwiperInstances || {};

function initializeSwipers() {
	// Find all hero swiper sections on the page
	const swiperSections = document.querySelectorAll(".hero-swiper");

	swiperSections.forEach(function (swiperElement) {
		// Get section ID from parent
		const section = swiperElement.closest(".hero-slider-section");
		if (!section) return;

		const sectionId = section.id;
		const autoplayEnabled = swiperElement.dataset.autoplay === "true";
		const autoplayDelay = parseInt(swiperElement.dataset.autoplayDelay) || 5000;
		const slideSpacing = parseInt(swiperElement.dataset.slideSpacing) || 32;
		const transitionSpeed =
			parseInt(swiperElement.dataset.transitionSpeed) || 1400;

		// Check if Swiper is loaded
		if (typeof Swiper === "undefined") {
			console.error("Swiper is not loaded");
			return;
		}

		// Store instance for cleanup
		if (window.heroSwiperInstances[sectionId]) {
			window.heroSwiperInstances[sectionId].destroy();
		}

		// Initialize Swiper
		const heroSwiper = new Swiper(`#${sectionId} .hero-swiper`, {
			// Basic parameters
			slidesPerView: 1.15,
			spaceBetween: slideSpacing,
			centeredSlides: true,
			loop: false,
			watchSlidesProgress: true,
			grabCursor: false,

			// Enable parallax
			parallax: true,

			// Autoplay
			autoplay: autoplayEnabled
				? {
						delay: autoplayDelay,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
				  }
				: false,

			// Navigation
			navigation: {
				nextEl: `#${sectionId} .swiper-button-next`,
				prevEl: `#${sectionId} .swiper-button-prev`,
			},

			// Pagination
			pagination: {
				el: `#${sectionId} .swiper-pagination`,
				clickable: true,
				renderBullet: function (index, className) {
					let html =
						'<span class="' +
						className +
						'" tabindex="0" role="button" aria-label="Go to slide ' +
						(index + 1) +
						'">';
					html +=
						'<span class="swiper-pagination-number">0' +
						(index + 1) +
						"</span>";
					html += '<span class="swiper-pagination-progress">';
					html += '<span class="swiper-pagination-progress-fill"></span>';
					html += "</span>";
					html += "</span>";
					return html;
				},
			},

			// Effects and transitions
			effect: "slide",
			speed: transitionSpeed,
			allowTouchMove: true,
			threshold: 5,

			// Responsive breakpoints
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 1.1,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 1.15,
					spaceBetween: slideSpacing,
				},
			},

			// Events
			on: {
				init: function () {
					updateNavigationButtons(this, sectionId);
					processTextAnimations(sectionId, swiperElement);
				},
				slideChange: function () {
					updateNavigationButtons(this, sectionId);
				},
				autoplayTimeLeft: function (swiper, timeLeft, percentage) {
					updateProgressBar(percentage, sectionId);
				},
			},
		});

		// Store the instance
		window.heroSwiperInstances[sectionId] = heroSwiper;

		// Keyboard navigation
		document.addEventListener("keydown", function (e) {
			if (e.key === "ArrowLeft") {
				heroSwiper.slidePrev();
			} else if (e.key === "ArrowRight") {
				heroSwiper.slideNext();
			}
		});
	});

	// Function to update navigation button visibility
	function updateNavigationButtons(swiper, sectionId) {
		const prevButton = document.querySelector(
			`#${sectionId} .swiper-button-prev`
		);
		const nextButton = document.querySelector(
			`#${sectionId} .swiper-button-next`
		);

		if (!swiper.params.loop && prevButton && nextButton) {
			// Fade prev button on first slide
			if (swiper.isBeginning) {
				prevButton.style.opacity = "0";
				prevButton.style.pointerEvents = "none";
			} else {
				prevButton.style.opacity = "1";
				prevButton.style.pointerEvents = "auto";
			}

			// Fade next button on last slide
			if (swiper.isEnd) {
				nextButton.style.opacity = "0";
				nextButton.style.pointerEvents = "none";
			} else {
				nextButton.style.opacity = "1";
				nextButton.style.pointerEvents = "auto";
			}
		}
	}

	// Function to update progress bar based on autoplay progress
	function updateProgressBar(percentage, sectionId) {
		// Get the active bullet's progress fill
		const activeProgressFill = document.querySelector(
			`#${sectionId} .swiper-pagination-bullet-active .swiper-pagination-progress-fill`
		);

		if (activeProgressFill) {
			// Convert percentage (0 to 1) to width (100% to 0%)
			const progress = (1 - percentage) * 100;
			activeProgressFill.style.width = progress + "%";
		}

		// Reset non-active progress bars
		const allProgressFills = document.querySelectorAll(
			`#${sectionId} .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) .swiper-pagination-progress-fill`
		);
		allProgressFills.forEach((fill) => {
			fill.style.width = "0";
		});
	}

	// Process text animations
	function processTextAnimations(sectionId, swiperElement) {
		const enableAnimation =
			swiperElement.dataset.enableTextAnimation === "true";
		if (!enableAnimation) return;

		// Animation is now handled via Liquid based on the enable_text_animation setting
		// No need to add classes dynamically
	}
}

// Initialize on DOM load
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initializeSwipers);
} else {
	initializeSwipers();
}

// Handle Shopify editor events for live preview
if (Shopify && Shopify.designMode) {
	document.addEventListener("shopify:section:load", function (event) {
		// Clean up existing instance if any
		const sectionId = event.detail.sectionId;
		if (window.heroSwiperInstances[sectionId]) {
			window.heroSwiperInstances[sectionId].destroy();
			delete window.heroSwiperInstances[sectionId];
		}
		// Reinitialize
		setTimeout(initializeSwipers, 100);
	});

	document.addEventListener("shopify:section:unload", function (event) {
		// Clean up when section is removed
		const sectionId = event.detail.sectionId;
		if (window.heroSwiperInstances[sectionId]) {
			window.heroSwiperInstances[sectionId].destroy();
			delete window.heroSwiperInstances[sectionId];
		}
	});

	document.addEventListener("shopify:block:select", function (event) {
		// Go to selected slide when block is selected in editor
		const blockElement = event.target;
		const slideIndex = parseInt(blockElement.dataset.index);
		const section = blockElement.closest(".hero-slider-section");
		if (section && !isNaN(slideIndex)) {
			const sectionId = section.id;
			const swiper = window.heroSwiperInstances[sectionId];
			if (swiper) {
				swiper.slideTo(slideIndex);
			}
		}
	});

	// Handle settings changes
	document.addEventListener("shopify:section:reorder", function () {
		// Destroy all instances
		Object.keys(window.heroSwiperInstances).forEach((sectionId) => {
			window.heroSwiperInstances[sectionId].destroy();
			delete window.heroSwiperInstances[sectionId];
		});
		// Reinitialize all
		setTimeout(initializeSwipers, 100);
	});

	// Handle section settings update (when any setting changes)
	document.addEventListener("shopify:section:select", function (event) {
		const sectionId = event.detail.sectionId;
		if (window.heroSwiperInstances[sectionId]) {
			// Destroy and reinitialize to reflect new settings
			window.heroSwiperInstances[sectionId].destroy();
			delete window.heroSwiperInstances[sectionId];
			setTimeout(initializeSwipers, 100);
		}
	});
}
